import { v4 as uuid } from 'uuid';
import { epoch, utc } from '../../util/datetime';
import { toUUID } from '../../util/transform';
import Address from '../address/Address';
import { OwnershipType } from '../global/OwnershipType.enum';
import { PropertyType } from '../global/PropertyType.enum';
import type { ITicketLoanPropertySplit } from './TicketLoanPropertySplit.interface';

export default class TicketLoanPropertySplit implements ITicketLoanPropertySplit {
  id: string;
  address: Address;
  lender: string;
  minimumValue: number;
  maximumValue: number;
  developmentName: string;
  lastSaleTimestamp: number;
  propertyType: PropertyType;
  ownershipType: OwnershipType;

  static build = (data: ITicketLoanPropertySplit) => new TicketLoanPropertySplit(data);
  static blank = () => new TicketLoanPropertySplit({ id: uuid() });

  /**
   * Constructor
   * @param {ITicketLoanPropertySplit} data
   */
  constructor(data?: ITicketLoanPropertySplit) {
    this.id = toUUID(data?.id) || uuid();
    this.address = new Address(data.address);
    this.lender = data?.lender || '';
    this.minimumValue = parseFloat(data?.minimumValue || 0);
    this.maximumValue = parseFloat(data?.maximumValue || 0);
    this.developmentName = data?.developmentName || '';
    this.lastSaleTimestamp = data?.lastSaleTimestamp ? epoch(utc(data?.lastSaleTimestamp)) : 0;
    this.propertyType = PropertyType.of(data?.propertyType?.name || `p${data?.propertyType}`);
    this.ownershipType = OwnershipType.of(
      data?.ownershipType?.name || data?.ownershipType?.toString()
    );
  }
}
